<template>
  <div>
    <div class="popup-title">注册信息</div>
    <cube-form :model="form">
      <div class="oinput">
        <cube-input placeholder="请输入供应商名称" v-model="form.orgName"></cube-input>
      </div>
      <div class="oinput">
        <cube-input placeholder="请输入联系人" v-model="form.name"></cube-input>
      </div>
      <div class="oinput">
        <cube-input @blur="vphone" placeholder="请输入手机号" type="number" v-model="form.phone"></cube-input>
      </div>
      <div class="oinput">
        <cube-input
          placeholder="请输入验证码"
          type="number"
          v-model="form.msgCode"
        ></cube-input>
        <cube-button
          :inline="true"
          :outline="false"
          @click="send"
          class="getcode"
          v-bind:class="{'isSend':isSend}"
        >{{sendCode}}</cube-button>
      </div>
     <div class="oinput address" @click="showAddress = true">
        {{address}}
      </div>
     <div class="oinput">
        <cube-input  placeholder="请输入详细地址" v-model="form.detailAddress"></cube-input>
      </div>
      <cube-button @click="register" class="login-btn">立即注册</cube-button>
    </cube-form>
    <div @click="goLogin" class="tips">
      已有帐户？
      <span class="red">立即登陆</span>
    </div>
    <v-address :visible="showAddress" @cancel="showAddress = false" @select="select"></v-address>
  </div>
</template>

<script>
import vAddress from "@/group/components/address/address.vue";
export default {
  data() {
    return {
      sendCode: '获取验证码',
      form: {
        orgType: 1, // 机构类型 1,供应商 2，维修厂
        source: 1, // 机构来源(0:袋鼠保 1:袋鼠团 2:袋鼠配
      },
      vphones: '',
      isSend: false,
      address: "请选择地区",
      showAddress: false,
    }
  },
  components:{
    vAddress
  },
  methods: {
    select(e) {
      console.log(e);
      this.showAddress = false;
      this.address = e[0].join("  ");
      this.form.provinceId = e[1][0];
      this.form.provinceName = e[0][0];
      this.form.cityId = e[1][1];
      this.form.cityName = e[0][1];
      this.form.districtId = e[1][2];
      this.form.districtName = e[0][2];
    },
    register() {
      if (!this.form.orgName) return this.$warn('请填写供应商名称!')
      if (!this.form.name) return this.$warn('请填写联系人!')
      if (!this.form.phone) return this.$warn('请填写手机号!')
      if (!/^\d{11}$/.test(this.form.phone)) return this.$warn('请输入正确的手机号!')
      if (!this.form.msgCode) return this.$warn('请填写验证码!')
      if (!this.form.provinceName) return this.$warn('请选择地区!')
      if (!this.form.detailAddress) return this.$warn('请填写详细地址!')
      this.$groupLoading().show()
      this.$groupPost('user/h5/org/registerSupplierByGroup', this.form).then(data => {
        this.$groupLoading().hide()
        if (data.errCode === 0) {
          this.$success('注册成功')
          this.$emit('success')
        }
      })
    },
    vphone(e) {
      window.scroll(0, 0)
      const phone = this.form.phone
      if (!/^\d{11}$/.test(phone)) {
        if (phone) {
          this.$warn('请输入正确的手机号')
        }
        this.vphones = false
        return false
      } else {
        this.vphones = true
      }
    },
    send() {
      if (this.vphones) {
        if (!this.isSend) {
          this.$groupLoading().show()
          this.$groupPost('user/h5/org/sendCodeRegisterSupplierByGroup', {
            phone: this.form.phone
          }).then(data => {
            this.$groupLoading().hide()
            if (data.errCode == 0) {
              this.isSend = true
              this.countDown(60)
              this.$success('发送成功！')
            }
          })
        }
      } else {
        this.$warn('请输入正确的手机号')
      }
    },
    countDown(num) {
      this.sendCode = `${num}s`
      const times = setInterval(() => {
        if (num == 0) {
          this.sendCode = '获取验证码'
          this.isSend = false
          clearInterval(times)
        } else {
          num--
          this.sendCode = `${num}s`
        }
      }, 1000)
    },
    reset() {
      this.form = {
        orgType: 1, // 机构类型 1,供应商 2，维修厂
        source: 1, // 机构来源(0:袋鼠保 1:袋鼠团 2:袋鼠配
      }
      this.address = '请选择地区'
    },
    goLogin() {
      this.$emit('change', 0)
    }
  },
  created() {},
  mounted() {}
}
</script>

<style lang='scss' scoped>
.popup-title {
  font-size: 34px;
  font-family: Arial;
  font-weight: 400;
  line-height: 37px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin-bottom: 25px;
}
.oinput {
  margin: 20px 0 30px;
  border-bottom: 1px solid rgba(235, 235, 235, 1); /*no*/
  display: flex;
  justify-content: start;
  align-items: center;
}
.getcode {
  background: #fff;
  flex-shrink: 0;
  font-size: 30px;
  font-family: Arial;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  border: none;
}
.isSend {
  color: #eb1d1e;
  border: none;
}
.login-btn {
  background: linear-gradient(
    270deg,
    rgba(233, 0, 0, 1) 0%,
    rgba(242, 86, 86, 1) 100%
  );
  color: #fff;
}
.tips {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-size: 32px;
  line-height: 44px;
  text-align: center;
  margin-top: 40px;
  color: #999;
  white-space: nowrap;
  .red {
    color: #eb1d1e;
    font-size: 32px;
  }
}
.address {
  padding: 20px 0;
  font-size: 35px;
}
</style>



// WEBPACK FOOTER //
// src/group/components/login/components/register.vue